import { MoneyBackGuaranteeIcon } from '@raysee/icon';
import { PageTitle } from '../layouts/PageTitle';

const CompanyMoneyBackGuarantee = () => {
  return (
    <section className="px-10 pb-5">
      <PageTitle title="返金保証について" />
      <p className="mt-2 text-sm leading-6">
        RAYSEEではチャット鑑定におきまして、対象の初回限定メニューに対し鑑定後のメニュー料金の全額返金保証を行っております。
      </p>
      <h3 className="mt-6 text-base font-bold text-black">返金保証の対象条件</h3>
      <p className="mt-1 text-sm leading-6">
        ・返金保証対象の初回限定メニューである*
        <br />
        ・本人が過去に返金保証の適用を受けたことがない
        <br />
        ・鑑定終了後7日以内の申請である
        <br />
      </p>
      <p className="ml-1 pt-2 text-[11px]">
        *
        メニュー画面でメニュータイトルの下に以下のアイコンが付いているものが返金保証の対象になります。
      </p>
      <p className="pt-1">
        <MoneyBackGuaranteeIcon width={74} height={24} />
      </p>
      <h3 className="mt-6 text-base font-bold text-black">申請方法</h3>
      <p className="mt-1 text-sm leading-6">
        下記のメールアドレスに必要事項を記載・添付してお送りください。
      </p>
      <p className="mt-2 text-base leading-6">support@raysee.jp</p>
      <h3 className="mt-4 text-sm font-bold text-black">【必要事項】</h3>
      <p className="mt-1 text-sm leading-6">
        ・メールアドレス
        <br />
        ・お電話番号
        <br />
        ・ご登録のニックネーム
        <br />
        ・当該鑑定の個別購入履歴ページのスクリーンショット
        <br />
        ・返金申請の理由
        <br />
      </p>
      <h3 className="mt-6 text-sm font-bold text-black">＊注記事項</h3>
      <p className="mt-1 pb-6 text-sm leading-6">
        ・返金申請はサービスのご利用を通して1回までです。同一人物により複数のアカウントから返金申請があったと判断した場合、該当する全てのアカウントを停止させていただくことがあります。
        <br />
        ・購入時に使用されたクーポンは還元されません。
        <br />
        ・返金申請は必ず鑑定が終了してから行ってください。
      </p>
    </section>
  );
};

export { CompanyMoneyBackGuarantee };
